import React from 'react';
import moment from 'moment';

const ordersTableConfig = () => ({
   columns: [
      { title: 'Invoice ID', field: 'invoice_id', filterAndSearch: true, width: '10%' },
      { title: 'Delivery Order ID', field: 'delivery_task_id', filterAndSearch: true, width: '10%' },
      {
         title: 'Seller Name', field: 'sellerDetails.name', filterAndSearch: true, width: '15%',
         render: rowData => <div>{rowData.sellerDetails.name || "-"}</div>
      },
      {
         title: 'Business Name', field: 'sellerDetails.businessDetails.business_name', filterAndSearch: true, width: '15%',
         render: rowData => <div>{(rowData && rowData.sellerDetails && rowData.sellerDetails.businessDetails && rowData.sellerDetails.businessDetails.business_name) || "-"}</div>
      },
      {
         title: 'Business Address', field: 'sellerDetails.businessDetails.address_line1', filterAndSearch: true, width: '15%',
         render: rowData => <div>{(rowData && rowData.sellerDetails && rowData.sellerDetails.businessDetails && rowData.sellerDetails.businessDetails.address_line1) || "-"}</div>
      },
      {
         title: 'Business Pincode', field: 'sellerDetails.businessDetails.pin_code', filterAndSearch: true, width: '15%',
         render: rowData => <div>{(rowData && rowData.sellerDetails && rowData.sellerDetails.businessDetails && rowData.sellerDetails.businessDetails.pin_code) || "-"}</div>
      },
      {
         title: 'Seller Mobile', field: 'sellerDetails.mobile_no', filterAndSearch: true, width: '15%',
         render: rowData => <div>{(rowData.sellerDetails && rowData.sellerDetails.mobile_no) || "-"}</div>
      },
      {
         title: 'Buyer Name', field: 'buyerDetails.name', filterAndSearch: true, width: '15%',
         render: rowData => <div>{rowData.buyerDetails && rowData.buyerDetails.name || "-"}</div>
      },
      {
         title: 'Buyer Email', field: 'buyerDetails.email_id', filterAndSearch: true,
         render: rowData => <div>{rowData.buyerDetails && rowData.buyerDetails.email_id || "-"}</div>
      },
      {
         title: 'Buyer Address', field: 'buyerDetails.address_line1', filterAndSearch: true,
         render: rowData => <div>{(rowData.buyerDetails && rowData.buyerDetails.address_line1) || "-"}</div>
      },
      {
         title: 'Buyer Pincode', field: 'buyerDetails.pin_code', filterAndSearch: true,
         render: rowData => <div>{(rowData.buyerDetails && rowData.buyerDetails.pin_code) || "-"}</div>
      },
      {
         title: 'Order Date', field: 'order_date_local', filterAndSearch: true, filtering: true,
         render: rowData => <div>{rowData.order_date_local ? (
            <div>{moment.utc(rowData.order_date_local).local().format("DD-MM-YYYY h:mm:ss a")}</div>
         ) : "-"}</div>
      },
      {
         title: 'Order Type', field: 'advance_booking', filterAndSearch: true, width: '12%',
         render: rowData => {
            const className = rowData.advance_booking ? "green-label" : "orange-label"
            return <div className={`text-capitalize colored-label ${className}`}>{rowData.advance_booking ? "Advance Booking" : "Normal Booking"}</div>
         }
      },
      {
         title: 'Order Amount', field: 'amount', filterAndSearch: true, width: '10%',
         render: rowData => <div>&#8377;{rowData.amount || "0"}</div>
      },
      {
         title: 'GST', field: 'tax', filterAndSearch: true, width: '10%',
         render: rowData => <div>&#8377;{rowData.tax || "0"}</div>
      },
      {
         title: 'Delivery Charge', field: 'delivery_charges', filterAndSearch: true, width: '10%',
         render: rowData => <div>&#8377;{rowData.delivery_charges || "0"}</div>
      },
      {
         title: 'Total Amount', field: 'net_amount', filterAndSearch: true, width: '10%',
         render: rowData => <div>&#8377;{rowData.net_amount || "0"}</div>
      },
      {
         title: 'Delivery Type', field: 'delivery_option.option_id', filterAndSearch: false,
         render: rowData => {
            let className = ""
            if (rowData.delivery_option && rowData.delivery_option.option_id) {
               className = rowData.delivery_option.option_code === "Dunzo" ? "colored-label green-label" : "colored-label orange-label"
            }
            return <div className={`text-capitalize ${className}`}>{(rowData.delivery_option && rowData.delivery_option.option_id && rowData.delivery_option.option_name) || "-"}</div>
         }
      },
      {
         title: 'Payment Status', field: 'payment.payment_status', filterAndSearch: true, width: '12%',
         render: rowData => <div className='text-capitalize'>{rowData.payment ? rowData.payment.payment_status.toLowerCase() : "-"}</div>
      },
      {
         title: 'Delivery Status', field: 'fulfillment_status', filterAndSearch: true, width: '12%',
         render: rowData => <div className='text-capitalize'>{rowData.fulfillment_status ? rowData.fulfillment_status.toLowerCase() : "-"}</div>
      }
   ],
})


export const data = [
   {
      id: 1,
      title: "date 1",
      groupByType: "Daily",
      no_of_items: 12,
      totalIncome: 100,
      orders: [
         {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         },
         {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }, {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }, {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }, {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }, {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }, {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }, {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }, {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }

      ]
   },
   {
      id: 2,
      title: "date 2",
      groupByType: "Daily",
      totalIncome: 100,
      no_of_items: 2,
      orders: [
         {
            order_id: "12",
            order_date_system: "12-12-12",
            net_amount: "23232",
            payment_status: "323",
            order_status: "2323",
         },
         {
            order_id: "232",
            order_date_system: "12-12-12",
            net_amount: "34343",
            payment_status: "sdfsd",
            order_status: "sfdsdf",
         }
      ]
   }
]

export default ordersTableConfig;